export default "\r\n<app-diagnosis-list></app-diagnosis-list>\r\n\r\n\r\n";